export const STREAM__DELETE_ITEMS = 'STREAM__DELETE_ITEMS';
export const STREAM__MOVE_ITEM = 'STREAM__MOVE_ITEM';
export const STREAM__REPLACE_ITEM = 'STREAM__REPLACE_ITEM';
export const STREAM__FETCH_FAILURE = 'STREAM__FETCH_FAILURE';
export const STREAM__FETCH_RETRY = 'STREAM__FETCH_RETRY';
export const STREAM__DELETE_STREAM = 'STREAM__DELETE_STREAM';
export const STREAM__SET_PARAM = 'STREAM__SET_PARAM';
export const STREAM__INSERT_ITEMS = 'STREAM__INSERT_ITEMS';

import {
  FetchFailureActionParams,
  FetchFailureAction,
  DeleteItemsActionParams,
  DeleteItemActionParams,
  DeleteItemsAction,
  DeleteStreamAction,
  MoveItemActionParams,
  MoveItemAction,
  ReplaceItemAction,
  SetParamActionParams,
  SetParamAction,
  InsertItemsActionParams,
  InsertItemsAction,
  StreamInitConfig,
} from './types';
import { createAction } from 'redux-actions';

export const initializeIfNeeded = createAction(
  'STREAM__INIT_IF_NEEDED',
  (streamId: string, config: StreamInitConfig) => ({ streamId, ...config })
);

export const fetchNext = createAction(
  'STREAM__FETCH_NEXT',
  (streamId: string) => ({ streamId })
);
export const fetchAll = createAction(
  'STREAM__FETCH_ALL',
  (streamId: string) => ({ streamId })
);
export const fetchPrevious = createAction(
  'STREAM__FETCH_PREVIOUS',
  (streamId: string) => ({ streamId })
);
export const fetchRetry = createAction(
  STREAM__FETCH_RETRY,
  (streamId: string) => ({ streamId })
);

export function fetch(
  streamId: string,
  direction?: 'next' | 'prev' | 'all' | 'retry'
) {
  switch (direction) {
    case 'prev':
      return fetchPrevious(streamId);
    case 'all':
      return fetchAll(streamId);
    case 'retry':
      return fetchRetry(streamId);
    case 'next':
    default:
      return fetchNext(streamId);
  }
}

export const deleteItem = ({
  streamId,
  item,
  doNotUpdateNextOffset,
  isEqual,
}: DeleteItemActionParams): DeleteItemsAction =>
  deleteItems({ streamId, items: [item], doNotUpdateNextOffset, isEqual });

export const deleteItems = ({
  streamId,
  items,
  doNotUpdateNextOffset,
  isEqual,
}: DeleteItemsActionParams): DeleteItemsAction => ({
  type: STREAM__DELETE_ITEMS,
  streamId,
  items,
  doNotUpdateNextOffset,
  isEqual,
});

export const moveItem = ({
  streamId,
  item,
  position,
}: MoveItemActionParams): MoveItemAction => ({
  type: STREAM__MOVE_ITEM,
  streamId,
  item,
  position,
});

export const fetchFailure = ({
  streamId,
  fetchType,
  errorMsg,
}: FetchFailureActionParams): FetchFailureAction => ({
  type: STREAM__FETCH_FAILURE,
  streamId,
  fetchType,
  errorMsg,
});

export const deleteStream = (streamId: string): DeleteStreamAction => ({
  type: STREAM__DELETE_STREAM,
  streamId,
});

export const replaceItem = ({
  streamId,
  newItem,
  predicate,
}): ReplaceItemAction => ({
  type: STREAM__REPLACE_ITEM,
  streamId,
  newItem,
  predicate,
});

export const insertItemsAtOffsets = ({
  streamId,
  newItems,
  deduplicate,
  doNotUpdateNextOffset,
}: InsertItemsActionParams): InsertItemsAction => ({
  type: STREAM__INSERT_ITEMS,
  streamId,
  newItems,
  deduplicate,
  doNotUpdateNextOffset,
});

export const setParam = ({
  streamId,
  paramType,
  paramValue,
}: SetParamActionParams): SetParamAction => ({
  type: STREAM__SET_PARAM,
  streamId,
  paramType,
  paramValue,
});

export const replaceItems = createAction(
  'STREAM__REPLACE_ITEMS',
  (streamId: string, updatedItems: any) => ({
    streamId,
    updatedItems,
  })
);

// use when you need to mark a stream for fetchinng without actually dispatching the fetch action
// eg. in storybook or some odd saga edge cases
export const markAsFetching = createAction(
  `STREAM__MARK_AS_FETCHING`,
  (streamId: string) => ({ streamId })
);

export const markAsCancelled = createAction(
  `STREAM__MARK_AS_CANCELLED`,
  (streamId: string) => ({ streamId })
);

export const cancelFetchForStream = createAction(
  `STREAM__CANCEL_FETCH`,
  (streamId: string) => ({ streamId })
);
